import React, { useState } from 'react';

import Image from '../../../../library/image/image';
import Tooltip from '../../../../library/tooltip/tooltip';
import Typography from '../../../../library/typography/typography';
import TreadwellPersonaIcon from '../../../treadwell-persona-icon/treadwell-persona-icon';

import { useMediaQuery } from '../../../../shared/hooks/hooks';

import { CmsToolTipsComponent } from '../../../../shared/types/graphql-types';

import './treadwell-driver-type-options.scss';

interface TreadwellDriverTypeOptionsProps {
  className?: string;
  driverPersonas?: Array<CmsToolTipsComponent>;
  onDriverTypeSelected: (driverType: CmsToolTipsComponent | null) => void;
  selectedDriverType?: {
    name: string;
  };
}

function TreadwellDriverTypeOptions(props: TreadwellDriverTypeOptionsProps) {
  const {
    className,
    driverPersonas,
    onDriverTypeSelected,
    selectedDriverType
  } = props;
  const { isMinSm } = useMediaQuery();
  const [showPriorities, setShowPriorities] = useState({
    persona1: false,
    persona2: false,
    persona3: false
  });

  return (
    <div className={className}>
      <div styleName="messaging">
        <Typography styleName="heading" tag="span">
          <Image
            alt="Treadwell"
            height="26px"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/treadwell-icon-only-trademark.svg"
            styleName="treadwell-logo"
          />
          What&nbsp;<strong>type</strong>&nbsp;of driver are you?
        </Typography>

        <Typography tag="span">
          Selecting your driver type helps Treadwell{' '}
          <strong>find your best tire match</strong>
        </Typography>
      </div>

      <div role="radiogroup" styleName="driver-type-options">
        {driverPersonas &&
          driverPersonas.map((driverType, i) => {
            const topThreePrioritiesArr = driverType.tooltips?.slice(0, 3);
            const personaNumber = `persona${i + 1}`;

            return (
              <div key={driverType.name} styleName="driver-type-option-wrap">
                <button
                  aria-checked={selectedDriverType?.name === driverType.name}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onDriverTypeSelected(
                      selectedDriverType?.name === driverType.name
                        ? null
                        : driverType
                    );
                  }}
                  role="radio"
                  styleName={
                    selectedDriverType?.name === driverType.name
                      ? 'driver-type-option-selected'
                      : 'driver-type-option'
                  }
                >
                  <Typography size="regular" variant="p" weight="black">
                    <span styleName="header-icon">
                      <TreadwellPersonaIcon
                        iconName={driverType.icon}
                        styleName="icon"
                      />
                      {driverType.name || 'Custom'}
                    </span>
                  </Typography>

                  <Typography
                    styleName="driver-type-option-description"
                    tag="div"
                  >
                    {driverType.description}
                  </Typography>

                  <div>
                    <hr />
                  </div>

                  {(isMinSm || (!isMinSm && showPriorities[personaNumber])) && (
                    <div styleName="priorities-container">
                      <Typography styleName="priorities-title" variant="p">
                        Priorities
                      </Typography>

                      <Typography styleName="priorities-list" tag="div">
                        {topThreePrioritiesArr?.map((priority, i) => {
                          if (priority) {
                            return (
                              <ol key={`column-${i}`}>
                                <li key={priority.id}>
                                  {`${i + 1}. ${priority.title}`}
                                  <Tooltip
                                    content={priority.tipText || ''}
                                    styleName="tooltip"
                                  />
                                </li>
                              </ol>
                            );
                          }
                        })}
                      </Typography>
                    </div>
                  )}
                  {!isMinSm && (
                    <div styleName="show-priorities-button-container">
                      <button
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          setShowPriorities(prev => ({
                            ...prev,
                            [personaNumber]: !prev[personaNumber]
                          }));
                        }}
                        styleName="show-priorities-button"
                      >
                        {showPriorities[personaNumber]
                          ? 'show less'
                          : 'show more'}
                      </button>
                    </div>
                  )}
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default TreadwellDriverTypeOptions;
